module.exports = __webpack_public_path__ + "files/feuillerat.04caf22e42e4fba33aa647f665fa7442.pdf";